import { gql } from 'graphql-tag';

export const mobileCompaniesQuery = gql`
  query MobileCompanies($featureFlag: String!, $first: Int) {
    companies(featureFlags: [$featureFlag], first: $first) {
      edges {
        node {
          company_id
          company_name
          feature_flags
        }
      }
    }
  }
`;

export const mobileCompanyNameQuery = gql`
  query MobileCompanyName($company_id: String!) {
    company(company_id: $company_id) {
      company_id
      company_name
    }
  }
`;

export const mobileToursQuery = gql`
  query MobileTours(
    $days: Int
    $carrierId: String
    $statusGroup: MobileTourStatusGroup
    $positions: MobileTourPositionsFilter
    $needsAction: Boolean
    $search: String
    $limit: Int
    $offset: Int
  ) {
    mobileTours(
      days: $days
      carrierId: $carrierId
      statusGroup: $statusGroup
      positions: $positions
      needsAction: $needsAction
      search: $search
      limit: $limit
      offset: $offset
    ) {
      dataAsOf
      count
      tours {
        tour_id
        shipper_transport_number
        transport_id
        start_time
        status
        abort_time
        carrier {
          company_id
          company_name
        }
        warnings {
          type
        }
        failureReason {
          type
        }
        vehicleAllocations {
          allocationDeviceType
          allocatedAt
          startTrackingAt
          vehicleLicensePlateNumber
        }
        visibilitySources {
          primaryEventSource
        }
      }
    }
  }
`;

export const mobileTourStatsQuery = gql`
  query MobileTourStats($days: Int) {
    mobileTourStats(days: $days) {
      dataAsOf
      days
      companies {
        carrierId
        carrierName
        enabledFlags
        mobile
        tracked
        completed
        failed
        ongoing
        needsAction
        withWarnings
        withoutPositions
      }
    }
  }
`;

export const mobileTrackingShareQuery = gql`
  query MobileTrackingShare($days: Int, $carrierId: String) {
    mobileTrackingShare(days: $days, carrierId: $carrierId) {
      dataAsOf
      points {
        date
        mobile
        tracked
      }
    }
  }
`;

export const mobileTourDetailsQuery = gql`
  query MobileTourDetails($tour_id: Int!) {
    tour(tour_id: $tour_id) {
      tour_id
      shipper_transport_number
      transport_id
      start_time
      status
      abort_time
      carrier {
        company_id
        company_name
      }
      warnings {
        type
        severity
      }
      failureReason {
        type
      }
      vehicleAllocations {
        allocationDeviceType
        allocatedAt
        startTrackingAt
        vehicleLicensePlateNumber
        isAutoAllocation
      }
      visibilitySources {
        primaryEventSource
      }
      externalEvents {
        eventId
        eventSource
        externalEventSource
        externalEventQualifier
        timestamp
      }
      stops {
        stop_id
        display_sequence_number
        status
        location {
          name
        }
      }
      events {
        ... on TourEvent {
          event_id
          event_name
          event_time
          vehicle_lat
          vehicle_lng
        }
        ... on StopEvent {
          event_id
          stopEventName: event_name
          event_time
          stop_id
        }
      }
    }
  }
`;

export const mobileTourSignalsQuery = gql`
  query MobileTourSignals($tour_id: Int!) {
    tour(tour_id: $tour_id) {
      tour_id
      mobileSession {
        createdAt
        expiresAt
        isActive
        pushProvider
        pushPlatform
        pushAppVersion
        hasPushToken
      }
      mobileInvitations {
        notificationId
        sentAt
        phoneNumber
        composedAt
        status
      }
      mobileAppEvents {
        timestamp
        name
        appVersion
        platform
        params {
          key
          value
        }
      }
    }
  }
`;

export const mobileDeviceBreakdownQuery = gql`
  query MobileDeviceBreakdown($days: Int) {
    mobileDeviceBreakdown(days: $days) {
      appVersions {
        label
        devices
      }
      operatingSystems {
        label
        devices
      }
    }
  }
`;
